import { render, staticRenderFns } from "./ChangeCardTemplate.vue?vue&type=template&id=f47fa922&"
import script from "./ChangeCardTemplate.vue?vue&type=script&lang=js&"
export * from "./ChangeCardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports